
        var result = require("!!../../../node_modules/css-loader/index.js!./book.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/book/book.component.css
// module id = 452
// module chunks = 2